const initialState = {
  arrPositionsData: [],
  arrHoldingsData: [],
  arrPositionsUpdateData: [],
  positionType: 'historical',
  showPositionsMTM: true,
  showHoldingsMTM: true,
  openIPOs: [],
  closedIPOs: [],
  upcomingIPOs: [],
  ipoOrders: [],
  arrHoldingsUpdatesData: [],
  cancelAmoOrder:[],
  positionMetrics: {
    totalRealizedPnL: 0,
    totalUnrealizedPnL: 0,
    totalPnL: 0,
    
  }
}

const getViewIpoData = (ipo) =>
  ipo.map((el) => {
    const newIpo = { ...el };
    newIpo.view = 'view';
    newIpo.placeBidBtn = 'PLACE BID';
    newIpo.bidDetailsBtn = 'BID DETAILS';
    newIpo.updateBidBtn = 'UPDATE BID';
    newIpo.cancelBidBtn = 'CANCEL BID';
    newIpo.calcDate = `${el.biddingStartDate} - ${el.biddingEndDate}`;
    newIpo.calcPrice = `${el.minPrice} - ${el.maxPrice}`;
    return newIpo;
  });

export default function reducer(state=initialState, action) {
  switch(action.type) {
    case 'SET_POSITIONS':
      return {
        ...state,
        arrPositionsData: [...action.payload]
      };
    case 'SET_POSITIONS_UPDATE':
      return {
        ...state,
        arrPositionsUpdateData: [...action.payload],
      };
    case "SET_PNL_UPDATE":
      return {
        ...state,
        positionMetrics: {
          ...state.positionMetrics,
          totalPnL: action.payload.totalPnl,
          realizedPnL: action.payload.realizedPnl,
          unrealizedPnL: action.payload.unrealizedPnl
        }
      };
    case 'SET_HOLDINGS':
      return {
        ...state,
        arrHoldingsData: [...action.payload],
     };
    case 'SET_HOLDINGS_UPDATE':
      return {
        ...state,
        arrHoldingsUpdatesData: [...action.payload],
    };
    case 'SET_POSITION_TYPE':
      return {
        ...state,
        positionType: action.payload
      };
    case 'SET_POSITIONS_MTM_ENABLED':
      return {
        ...state,
        showPositionsMTM: action.payload
      };
    case 'SET_HOLDINGS_MTM_ENABLED':
      return {
        ...state,
        showHoldingsMTM: action.payload
      };
    case 'SET_ALL_IPOS':
      const openIPOsData = getViewIpoData([...action.payload.open_ipo]);
      const closedIPOsData = getViewIpoData([...action.payload.closed_ipo]);
      const upcomingIPOsData = getViewIpoData([...action.payload.upcoming_ipo]);
      return {
        ...state,
        openIPOs: openIPOsData,
        closedIPOs: closedIPOsData,
        upcomingIPOs: upcomingIPOsData
      }
    case 'SET_IPO_ORDERS':
      return {
        ...state,
        ipoOrders: [...action.payload]
      }
      case 'SET_AMO_IPO_ORDERS':
        return{
          ...state,
          cancelAmoOrder: [...action.payload]
        }
    case 'UPDATE_POSITION_SELECTION':
      return {
        ...state,
        arrPositionsUpdateData: state.arrPositionsUpdateData.map(position => {
          if (
            position.token === action.payload.position.token &&
            position.exchange === action.payload.position.exchange &&
            position.product === action.payload.position.product
          ) {
            return {
              ...position,
              isSelected: action.payload.isSelected
            };
          }
          return position;
        })
      };
    case 'SET_ALL_POSITIONS_SELECTION':
      return {
        ...state,
        arrPositionsUpdateData: state.arrPositionsUpdateData.map(position => ({
          ...position,
          isSelected: action.payload && position.net_quantity !== 0
        }))
      };
    default:
      return state;
  }
}
